import { c as _c } from "react/compiler-runtime";
import { Text } from 'platform/foundation-tw';
import { CellRendererProps } from '../../types/CellRendererProps';
type FileEntry = {
  title?: string;
};
type FilePlainCellRendererProps = CellRendererProps<unknown>;
export function FilePlainCellRenderer(props) {
  const $ = _c(2);
  const values = props.value as FileEntry | undefined;
  const t0 = values?.title;
  let t1;
  if ($[0] !== t0) {
    t1 = <Text size="small">{t0}</Text>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}